export const getAbsLink = (link) => /^\w+:\/\/|^www\./.test(link) ? link : "/" + link;